import { roleHasDealershipCapability } from "../models/dealershipCapabilities.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Staff queue for dealership appointment accept / decline / cancel. */
export class StaffAppointmentsViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ appointments: [], loading: false, error: null });
        this.client = client;
    }
    canAccess() {
        const role = this.client.claims()?.role ?? "";
        return roleHasDealershipCapability(role, "appointments:staff");
    }
    async load() {
        if (!this.canAccess()) {
            this.setState({ appointments: [], error: null });
            return;
        }
        await this.run(async () => {
            const appointments = await this.client.listAppointmentsStaff();
            this.setState({ appointments });
        }, "Failed to load appointments.");
    }
    async accept(id) {
        if (!this.canAccess())
            return false;
        const ok = await this.run(async () => {
            await this.client.acceptAppointment(id);
            await this.load();
            return true;
        }, "Failed to accept appointment.");
        return ok === true;
    }
    async decline(id) {
        if (!this.canAccess())
            return false;
        const ok = await this.run(async () => {
            await this.client.declineAppointment(id);
            await this.load();
            return true;
        }, "Failed to decline appointment.");
        return ok === true;
    }
    async cancel(id) {
        if (!this.canAccess())
            return false;
        const ok = await this.run(async () => {
            await this.client.cancelAppointment(id);
            await this.load();
            return true;
        }, "Failed to cancel appointment.");
        return ok === true;
    }
}
//# sourceMappingURL=StaffAppointmentsViewModel.js.map